import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  computed: {
    html: function html() {
      var content = this.content;
      content = content.replace(/(<img[^>]+>)/g, function (match) {
        return match.replace(/height="[\d]+[\\.]?[\d]*"/g, '');
      });
      content = content.replace(/(<table[^>]+>)/g, function (match) {
        return match.replace(/height="[\d]+[\\.]?[\d]*"/g, '');
      });
      content = content.replace(/(<video[^>]+>)/g, function (match) {
        return match.replace(/controls=""/, '').replace(/>/, ' controls="" playback-rate="1" x5-playsinline="true" playsinline="true" webkit-playsinline="true" x-webkit-airplay="allow" x5-video-orientation="portrait" preload="true" autoplay style="object-fit: scale-down;min-width: 100%;width:100%;min-height:232px;height: auto;">');
      });
      return content;
    }
  },
  methods: {},
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};